import classNames from "classnames";

import styles from "./LogoIcon.module.css";

type LogoIconProps = {
  className?: string;
  pharmacyName: string;
  pharmacyLogoPath: string;
};

export default function LogoIcon(props: LogoIconProps) {
  return (
    <div className={classNames(styles.container, props.className)}>
      <img
        src={props.pharmacyLogoPath}
        alt={props.pharmacyName}
        className={styles.img}
      />
    </div>
  );
}
